<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view >
      </router-view>
    </transition>
    <Loader :loaderType="{ loading: this.model.isLoading }"/>
    <IllustrationPreview/>
    <navigation v-if="navigationVisible"></navigation>
    <simple-navigation v-else></simple-navigation>
  </div>
</template>

<script>
import '@/filters';
import { mapGetters } from 'vuex';
import Loader from '@/components/Loader.vue';
import { japiPost } from '@/api';
import IllustrationPreview from '@/components/IllustrationPreview.vue';

export default {
  name: 'App',
  computed: {
    navigationVisible() { return this.$route.meta?.step <= 3; },
    ...mapGetters({
      model: 'getModel',
    }),
  },
  components: { Loader, IllustrationPreview },
  async created() {
    this.$store.commit('SET_LOADING', true);
    const toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];
    this.$store.commit('SET_ISMOBILE', toMatch.some((toMatchItem) => navigator.userAgent.match(toMatchItem)));
    const { hash } = this.$route.query;
    if (hash) {
      try {
        const inspection = await japiPost('IPzpUploadApi/loadInspection', [hash]);
        const loadStep = await this.$store.dispatch('loadInspection', inspection);
        this.$router.goToStep(loadStep);
        /*
        * // clear query
        * const query = JSON.parse(JSON.stringify({}));
        * this.$router.replace({ query });
        */
      } catch (e) {
        this.$router.goToStep(1);
        this.$store.dispatch('validateStep');
      }
    }
    let showErrorPage = false;
    try {
      await this.$store.dispatch('checkServiceAvailability');
      if (!this.model.serviceAvailability) {
        showErrorPage = true;
      }
      this.$store.commit('SET_LOADING', false);
    } catch (error) {
      this.$store.commit('SET_LOADING', false);
      showErrorPage = true;
    }
    if (showErrorPage) {
      this.$store.commit('SET_STEP', 5);
      this.$router.goToStep(this.model.step);
    }
  },
};
</script>

<style lang="scss">
  @import "~union_styles/scss/variables";
  @import "~union_styles/scss/application";

  .icon--union {
    background-image: url(https://www.union.sk/wp-content/uploads/2020/08/logo-union_claim.svg);
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.25s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
  .select-box-holder.has-value.input-dirty i.icon--tooltip-icon {
    display: none !important;
  }

  .select-box-holder.has-value i.icon--status-ok, .input-box-holder.has-value.is-valid i.icon--status-ok {
    display: block !important;
  }
</style>
